// Firebase configuration for Admin Dashboard
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase config for ovuloom-femtech (development)
const firebaseConfig = {
    apiKey: 'AIzaSyAnfrWVGwV8Lyv18gEBxCDOz4vj-e05iko',
    authDomain: 'ovuloom-femtech.firebaseapp.com',
    projectId: 'ovuloom-femtech',
    storageBucket: 'ovuloom-femtech.firebasestorage.app',
    messagingSenderId: '1020025104352',
    appId: '1:1020025104352:web:1dcf6d384418ab54b7ed85'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

// Cloud Functions URL
export const FUNCTIONS_URL = 'https://us-central1-ovuloom-femtech.cloudfunctions.net';

export default app;
